(($)=>{

	const blockRootSelector = '.section.full-width-block'; // can be any css valid selector for wrapper of block
	const blockName = 'fullWidthBlock'; // please use `camelCase` for functions and `CamelCase` with first capital if it's class name

	/// All logic and initialization is inside this function.
	function initializeBlock(el){

		const $block = $(el);
		const $content = $('#content');
		let updateTimer;


		$(window).resize(function(event) {

				clearTimeout( updateTimer );

				updateTimer = setTimeout(function(){
					let left = $content.offset().left + 15;

					$block.css({
						marginLeft: -left,
						width: '100vw'
					});
				}, 10);

			}).trigger('resize');

		return el;
	}


	//we initialize blocks of this type which are already rendered on page not via ajax.
	$(blockRootSelector).each((index, el) => {

		const blockId = `wpshopify_initial_${blockName}_${index}`;

		window.WPShopify.blockInstances[blockId] = {
			el: el,
			id: blockId,
			blockInitFunctionName: blockName,
			instance: initializeBlock(el)
		};

	});

	// save our block initializer function to storage to make it possible to init blocks of same type loaded by ajax.
	window.WPShopify.blocksInits[blockName] = initializeBlock;


})(jQuery);